export default {
  apiKey: 'AIzaSyD1aDE9k9sfGRq-3RaQw7ohoBizOPofins',
  authDomain: 'auth.improvee.io',
  databaseURL: 'https://life-coach-vue.firebaseio.com',
  projectId: 'life-coach-vue',
  storageBucket: 'life-coach-vue.appspot.com',
  messagingSenderId: '1065523862270',
  appId: '1:1065523862270:web:62dadcdb3d7dcf416723af',
  measurementId: 'G-NWJ01Q41H4'
}
